import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/index/p1.jpg'
import _imports_1 from '../assets/index/a1.png'
import _imports_2 from '../assets/index/a2.png'
import _imports_3 from '../assets/index/a3.png'
import _imports_4 from '../assets/index/b1.png'
import _imports_5 from '../assets/index/b2.png'
import _imports_6 from '../assets/index/b3.png'


const _withScopeId = n => (_pushScopeId("data-v-c2b44356"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  style: {"height":"100%","width":"100%"}
}, null, -1))
const _hoisted_2 = { class: "container marketing" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mt-5 mb-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "class-title" }, "平台优势"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-lg-4 justify-content-center",
    style: {"display":"flex"}
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "card",
      style: {"width":"16rem","border":"0"}
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_1,
        class: "card-img-top",
        alt: ""
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
        /*#__PURE__*/_createElementVNode("h5", { class: "card-title text-center mb-4" }, "算法业界翘楚"),
        /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, "平台采用业界先进的深度学习算法，实现语音识别和声纹识别功能。在相关领域有大量的应用案例和语音数据积累。")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-lg-4 justify-content-center",
    style: {"display":"flex"}
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "card",
      style: {"width":"16rem","border":"0"}
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_2,
        class: "card-img-top",
        alt: ""
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
        /*#__PURE__*/_createElementVNode("h5", { class: "card-title text-center mb-4" }, "支持多平台接入"),
        /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, "提供REST API和SDK服务，支持智能硬件终端，移动应用，网站应用，桌面应用端和其他需要接入的设备终端。")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-lg-4 justify-content-center",
    style: {"display":"flex"}
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "card",
      style: {"width":"16rem","border":"0"}
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_3,
        class: "card-img-top",
        alt: ""
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
        /*#__PURE__*/_createElementVNode("h5", { class: "card-title text-center mb-4" }, "定制化&私有化"),
        /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, "提供深度定制服务，根据具体的行业业务需求定制，识别更加精准。支持私有化部署，保障客户数据信息安全。")
      ])
    ])
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "class-title" }, "产品服务", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mt-5 mb-5" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-lg-4 justify-content-center",
    style: {"display":"flex"}
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "card",
      style: {"width":"16rem","border":"0"}
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_4,
        class: "card-img-top",
        alt: ""
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
        /*#__PURE__*/_createElementVNode("h5", { class: "card-title text-center mb-4" }, "语音识别"),
        /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, "天聪语音识别技术能够快速的实现从语音到文字的过程。")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-lg-4 justify-content-center",
    style: {"display":"flex"}
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "card",
      style: {"width":"16rem","border":"0"}
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_5,
        class: "card-img-top",
        alt: ""
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
        /*#__PURE__*/_createElementVNode("h5", { class: "card-title text-center mb-4" }, "声纹识别"),
        /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, "采用口令或文本进行声纹认证，实时精准可靠。")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-lg-4 justify-content-center",
    style: {"display":"flex"}
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "card",
      style: {"width":"16rem","border":"0"}
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_6,
        class: "card-img-top",
        alt: ""
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
        /*#__PURE__*/_createElementVNode("h5", { class: "card-title text-center mb-4" }, "语音合成"),
        /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, "提交文本，转换成自然流畅的语音。")
      ])
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_divider),
      _hoisted_4,
      _hoisted_5
    ])
  ], 64))
}